<div class="e-modal-dialog e-modal-dialog-centered" role="dialog" aria-modal="true">
  <div class="e-modal-content">

    <div class="e-modal-header">
      <h1 class="e-modal-title">Company Search</h1>
      <button type="button" class="e-close" aria-label="Close" (click)="onCancel()">
        <span class="fal fa-times" title="Close"></span>
      </button>
    </div>
    <div class="e-modal-body">
      <div class="e-company-search-layout">
        <div class="e-company-search-left">
          <div class="e-search-input-wrapper">
            <input id="companySearchInput" class="form-input" type="text" [(ngModel)]="searchText"
              (input)="onSearchInput(searchText)" placeholder="Type to search" />
            <span class="fas fa-search e-search-icon"></span>
          </div>
          <div class="e-results-container">

            @if (!isLoading) {
            <div class="e-grid-wrap">
              <ag-grid-angular class="e-company-search-grid ag-theme-alpine" [rowData]="gridData"
                [gridOptions]="gridOptions" [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                (bodyScrollEnd)="onBodyScrollEnd($event)" (rowClicked)="onSearchResultClicked($event)"
                [tooltipShowDelay]="agGridInputs.tooltipShowDelayMilliSeconds">
              </ag-grid-angular>

              @if (excessData) {
              <div class="centered-container">
                <span>
                  Showing top 25 matches of a possible {{ count }}
                </span>
                <a class="loadMoreLink" (click)="loadAllSearchResults()">
                  Load All Matches
                </a>
              </div>
              }
            </div>
            } @else {
            <div class="e-result-row e-result-row-loading">
              <span class="fas fa-spinner-third fa-spin"></span>
              <span class="e-loading-text">
                Searching companies...
              </span>
            </div>
            }

          </div>
        </div>
        <div class="e-company-search-right">

          <div class="e-selection-header">
            <h2 class="e-selection-title">Your Selections</h2>
            <button type="button" class="e-clear-all-button" (click)="clearSelection()" [disabled]="!selectedCompany"
              aria-label="Clear all selections">
              Clear All
            </button>
          </div>
          <div class="e-selection-section">
            <div class="e-selection-label">Pre-Populated Company</div>
            <div class="e-selection-value e-selection-value-muted">
              {{ prePopulatedCompanyDisplay }}
            </div>
          </div>
          <div class="e-selection-section">
            <div class="e-selection-label">Search Result</div>

            @if (selectedCompany) {
            <div class="e-selection-value">
              {{ selectedCompany.brandCompanyName }}
            </div>
            } @else {
            <div class="e-selection-value e-selection-value-muted">
              Result will appear here
            </div>
            }
          </div>

          <div class="e-buttons-footer">
            <button type="button" class="e-dialog-button e-cancel-dialog-button" (click)="onCancel()">
              CANCEL
            </button>

            <button type="button" class="e-dialog-button" [disabled]="!selectedCompany" (click)="onAdd()">
              ADD
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>